// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root {
    height: 100%;
    margin: 0;
}

.all_chats {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
}

.top_box {
    flex: 0 0 85%;
    background-color: red;
    /* //margin-bottom: 5%; Add vertical gap */
}

.bottom_box {
    flex: 0 0 10%;
    background-color: blue;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    gap: 1rem;
    margin-top: auto; /* Push to bottom */
}

.input_box {
    flex: 0 0 60%;
    height: 70%;
}

.submit_button {
    flex: 0 0 auto;
    height: 70%;
    padding: 0.5rem 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/Component/all_chats/AllChats.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,gBAAgB,EAAE,mBAAmB;AACzC;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,oBAAoB;AACxB","sourcesContent":["html, body, #root {\n    height: 100%;\n    margin: 0;\n}\n\n.all_chats {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    width: 100vw;\n}\n\n.top_box {\n    flex: 0 0 85%;\n    background-color: red;\n    /* //margin-bottom: 5%; Add vertical gap */\n}\n\n.bottom_box {\n    flex: 0 0 10%;\n    background-color: blue;\n    display: flex;\n    align-items: center;\n    padding: 0 1rem;\n    gap: 1rem;\n    margin-top: auto; /* Push to bottom */\n}\n\n.input_box {\n    flex: 0 0 60%;\n    height: 70%;\n}\n\n.submit_button {\n    flex: 0 0 auto;\n    height: 70%;\n    padding: 0.5rem 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
